import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function CustomerUpdates() {

  const updates = [
    {
      category: "Roads",
      date: "02 Jun 2025",
      title: "Zone 3 road widening complete",
      description:
        "The main access road has been widened to 12 feet for better vehicle access.",
      important: true
    },
    {
      category: "Plantation",
      date: "28 May 2025",
      title: "Summer plantation drive – 50 saplings added",
      description:
        "Mango and coconut saplings planted across Zone 3 plots."
    },
    {
      category: "General",
      date: "20 May 2025",
      title: "Bore well #6 maintenance done",
      description:
        "Annual servicing completed. Water supply restored."
    }
  ];

  return (
    <>
      <Navbar />
      <Sidebar />

      <div className="main-content">

        <div className="customer-updates-page">

          <h2>Estate Updates</h2>

          {updates.map((item, index) => (

            <div
              key={index}
              className="update-card"
            >

              <div className="update-header">

                <span className="update-category">
                  {item.category}
                </span>

                <span className="update-date">
                  {item.date}
                </span>

                {item.important && (
                  <span className="update-important">
                    Important
                  </span>
                )}

              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>

          ))}

        </div>

      </div>
    </>
  );
}

export default CustomerUpdates;